import { Link } from "react-router";
import { Button } from "../../components/Button";
import { ReadinessRing } from "../../components/ReadinessRing";

const PROOF = [
  { figure: "20,000+", label: "past questions" },
  { figure: "JAMB & WAEC", label: "both exams" },
  { figure: "Offline", label: "works without data" },
];

/**
 * Screen 1 — the only screen that is not the 480px column.
 *
 * Exam neutrality is a spec rule, not a preference: pre-signup surfaces name
 * both exams or neither, and WAEC never gets a single countdown because it has
 * two sittings (May/June and Nov/Dec).
 */
export function LandingScreen() {
  return (
    <div className="mx-auto flex min-h-dvh w-full max-w-[480px] flex-col px-5 pb-8 pt-6">
      <header className="flex items-center justify-between">
        <span className="font-[family-name:var(--font-display)] text-[19px] font-bold">
          Prep<span className="text-accent">AI</span>
        </span>
        <span className="tabular rounded-[var(--radius-chip)] border border-border bg-surface px-2.5 py-1.5 text-[11px] text-text-muted">
          JAMB April · WAEC May &amp; Nov
        </span>
      </header>

      <div className="flex flex-col gap-3 pt-10">
        <h1 className="m-0 font-[family-name:var(--font-display)] text-[clamp(2rem,8vw,2.5rem)] font-bold leading-[1.05] tracking-[-0.02em]">
          Know exactly how ready you are.
        </h1>
        <p className="m-0 text-[15px] leading-[1.55] text-text-muted">
          Practice real past questions free — see your readiness score in minutes.
        </p>
      </div>

      <div className="flex flex-col items-center gap-4 pt-10">
        <ReadinessRing percentage={63} band="building" />
        <p className="m-0 max-w-[280px] text-center text-[13px] leading-[1.5] text-text-muted">
          Your Readiness — one number that moves every time you practice.
        </p>
      </div>

      <ul className="m-0 grid grid-cols-3 gap-2 p-0 pt-10">
        {PROOF.map((item) => (
          <li
            key={item.label}
            className="flex list-none flex-col gap-1 rounded-[var(--radius-card)] border border-border bg-surface p-3 text-center"
          >
            <span className="tabular text-[13px] font-bold">{item.figure}</span>
            <span className="text-[11px] leading-[1.3] text-text-muted">{item.label}</span>
          </li>
        ))}
      </ul>

      <div className="mt-auto flex flex-col gap-3 pt-10">
        <Link to="/signup">
          <Button>Start practicing free</Button>
        </Link>
        <p className="m-0 text-center text-[13px] text-text-muted">
          Already have an account?{" "}
          <Link to="/login" className="font-semibold text-accent">
            Log in
          </Link>
        </p>
      </div>
    </div>
  );
}
